import { css } from "styled-components";
import { CourseNameCss, NoteCss, UnitPriceAmount, UnitPriceRoot, UnitPriceUnit } from "components/front/layout/content/CourseListCss";

const BG_COLOR_GRAY = "rgba(104, 104, 104, 0.5)";
const BG_COLOR_GRAY_DARK = "rgba(36, 36, 36, 0.5)";
const ProjectContentCss = css`
  .content-box1 {
    .main-bg {
      @media screen and (max-width: 960px) {
        padding: 20px 10px 10px;
        font-size: 13px;
        line-height: 1.428em;
      }
      @media screen and (min-width: 961px) and (max-width: 1280px) {
        padding: 20px;
        font-size: 13px;
        line-height: 1.65em;
      }
      @media screen and (min-width: 1281px) {
        padding: 20px;
        font-size: 15px;
        line-height: 1.65em;
      }
    }
    .top-bg {
      width: 100%;
      height: 16px;
      position: relative;

      &:before {
        content: "";
        width: calc(100% - 16px);
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
      }

      &:after {
        content: "";
        border-style: solid;
        border-width: 0 16px 16px 0;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .bottom-bg {
      width: 100%;
      height: 16px;
      position: relative;

      &:before {
        content: "";
        width: calc(100% - 20px);
        height: 16px;
        position: absolute;
        top: 0;
        right: 0;
      }

      &:after {
        content: "";
        border-style: solid;
        border-width: 16px 0 0 16px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    &.gray {
      .main-bg {
        background-color: ${BG_COLOR_GRAY};
        border-right: 4px solid ${BG_COLOR_GRAY_DARK};
      }
      .top-bg {
        &:before {
          background-color: ${BG_COLOR_GRAY};
        }
        &:after {
          border-color: transparent transparent ${BG_COLOR_GRAY} transparent;
        } 
      }
      .bottom-bg {
        &:before {
          background-color: ${BG_COLOR_GRAY};
          border-right: 4px solid ${BG_COLOR_GRAY_DARK};
          border-bottom: 4px solid ${BG_COLOR_GRAY_DARK};
        }
        &:after {
          border-color: ${BG_COLOR_GRAY} transparent transparent transparent;
        }
      }
    }
  }
  .content-subtitle {
    color: white;
    margin-bottom: 10px;
    display: inline-block;
    line-height: 1;
    border-left: 5px solid white;
    padding-left: 8px;
    @media screen and (max-width: 960px) {
      font-size: 16px;
    }
    @media screen and (min-width: 961px) and (max-width: 1280px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1281px) {
      font-size: 20px;
    }
  }
  .content-caption {
    background-color: rgba(104, 104, 104, 0.5);
    width: 100%;
    display: inline-block;
    color: white;
    margin: 5px 0 10px;
    line-height: 1;
    @media screen and (max-width: 960px) {
      text-align: center;
      padding: 5px;
      font-size: 16px;
    }
    @media screen and (min-width: 961px) {
      text-align: left;
      padding: 10px;
      font-size: 20px;
    }
    @media screen and (min-width: 1281px) {
      font-size: 22px;
    }
  }
  .content-price {
    ${UnitPriceRoot};
    .amount {
      ${UnitPriceAmount};
    }
    .unit {
      ${UnitPriceUnit};
    }
  }
  .content-name {
    ${CourseNameCss};
  }
  .content-note {
    ${NoteCss};
  }
`;
export default ProjectContentCss;
